/* eslint-disable no-nested-ternary */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable radix */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable array-callback-return */
/* eslint-disable no-console */
/* eslint-disable no-mixed-operators */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable import/extensions */
import { useState, useRef, useEffect } from "react";
import dynamic from "next/dynamic";
import { END } from "redux-saga";
import { loadSelf } from "@fdn/profile_store";
import Env from "Consts/env";
import Cookies from "js-cookie";
import * as ServerCookies from "cookies";
import Data from "Consts/data";
import { useRouter } from "next/router";
import Axios from "axios";
import {
	createCart,
	ScrollToUp,
	isProduction,
	getProductRecommendations,
} from "Helpers/utils";
import * as metaPixel from "Helpers/fb-pixel";
import * as tiktokPixel from "Helpers/tiktok-pixel";
import * as gtag from "Helpers/gtag";
import { useDispatch } from "react-redux";
import { wrapper } from "@/Store/index";
import { loadBrands } from "@/Store/brands_store/lib/actions";
import { loadCategoryDesktop } from "@/Store/category_desktop_store/lib/actions";
import { loadCartBadgeCount } from "@/Store/cart_badge_count_store/lib/actions";

const Mobile = dynamic(() => import("./mobile"));
const Desktop = dynamic(() => import("./desktop"));
const Layout = dynamic(() => import("Containers/layout"));
const Drawer = dynamic(() => import("Components/drawer"), { ssr: false });
const Loader = dynamic(() => import("@fdn/loader"), { ssr: false });
const Popup = dynamic(() => import("Components/pdp-popup"), { ssr: false });
const AddToCartPopup = dynamic(() => import("Components/add-to-cart-popup"), { ssr: false });
const ModalQuickReview = dynamic(() => import("Components/modal-quick-review"), { ssr: false });
const ChildDetailQuickReview = dynamic(() => import("Containers/child-detail-quick-review"), { ssr: false });

const Slug = (props) => {

	const dispatch = useDispatch();

	const data = props;
	const router = useRouter();

	const [isShowFilter, setShowFilter] = useState(false);
	const [isShowSorter, setShowSorter] = useState(false);

	const [filter, setFilter] = useState({
		category: data?.query?.category ? data?.query?.category?.split(",") : [],
		minPrice: data?.query?.min_price ?? "",
		maxPrice: data?.query?.max_price ?? "",
		onSale: Number(data?.query?.sale) || 0,
	});

	const [sorting, setSorting] = useState(data?.sorting);
	const [sale, setSale] = useState(false);

	const [showCategoryFilter, setShowCategoryFilter] = useState(false);
	const [showAllCategories, setShowAllCategories] = useState(false);
	const [categoriesMenu, setCategoriesMenu] = useState(data?.listCategory);
	const [brands, setBrands] = useState();
	const [isLoading, setIsLoading] = useState(false);
	const [total, setTotal] = useState(0);
	const [totalPage, setTotalPage] = useState(0);
	const [page, setPage] = useState(Number(data?.query?.page) || 1);

	const BrandDetail = data.storeBrands?.data;

	/* START STATE HANDLE QUICK REVIEW */
	const [isModalQuickReview, setModalQuickReview] = useState(false);
	const [isLoadingQuickReview, setIsloadingQuickReview] = useState(false);
	const [productQuickReview, setProductQuickReview] = useState(false);
	/* END STATE HANDLE QUICK REVIEW */

	const [popupShow, setPopupShow] = useState({
		show: false,
		message: "",
		color: "#323942",
		redirect: false,
		closable: false,
	});
	const [addToCartLoading, setAddToCartLoading] = useState(false);
	const [addToCartPopupShow, setAddToCartPopupShow] = useState({
		show: false,
		addedProduct: {},
		productRecommendations: [],
	});

	const HandleLoadMore = async (e) => {

		try {

			ScrollToUp();
			setPage(e);

		} catch (err) {

			setPopupShow({
				show: true,
				message: "Something went wrong. Please try again later.",
				color: "#323942",
			});

		}

	};

	const loader = useRef(null);

	// api call to get new page
	useEffect(async () => {

		if (Object.keys(BrandDetail).length > 0) {

			setIsLoading(true);
			if (brands !== undefined) {

				// set router
				router.push(
					`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/brands/${
						data?.query?.slug
					}?page=${page
					}&limit=${
						data.isMobile ? "8" : "16"
					}&category=${filter.category
					}&sort=${sorting || ""
					}&min_price=${filter?.minPrice
					}&max_price=${filter?.maxPrice
					}&sale=${filter?.onSale
					}&placement=2`,
					undefined,
					{ shallow: true },
				);

			}

			// fetch new data
			const dataBrands = await Axios(
				`${
					process.env.NEXT_PUBLIC_ROOT_DOMAIN
				}/api/fds-product?page=${page}&brand=${
					BrandDetail?.brand_id
				}&category=${filter?.category || ""
				}&sale=${filter?.onSale
					? "1"
					: "0"
				}&min_price=${filter.minPrice || ""
				}&max_price=${filter.maxPrice || ""
				}&sort=${sorting || ""
				}&limit=${
					data.isMobile ? "8" : "16"
				}&placement=2`,
			);

			const dataBrandsData = dataBrands?.data;

			if (dataBrandsData?.meta?.code === 200) {

				setTotal(parseInt(dataBrandsData.pagination.total));
				setTotalPage(parseInt(dataBrandsData.pagination.total_page));

				const brandsList = dataBrandsData.data?.products ?? [];

				setBrands(brandsList);
				setIsLoading(false);

			} else {

				setBrands([]);
				setIsLoading(false);

			}

		}

	}, [page, filter?.category?.length, filter?.minPrice, filter?.maxPrice, filter?.onSale, sorting]);

	const HandleFilter = (type, val, input) => {

		let temp = val;

		if (!input) {

			temp = Array.isArray(val) ? val : [...filter[type], val];

		}

		setFilter({
			...filter,
			[type]: temp,
		});

	};

	const HandleFilterRemove = (type, val) => {

		if (type === "price") {

			setFilter({
				...filter,
				minPrice: "",
				maxPrice: "",
			});

		} else {

			setFilter({
				...filter,
				[type]: type === "onSale" ? val : filter && filter[type].filter((i) => (
					i !== val && i !== val?.id && i !== val?.slug
				)),
			});

		}

	};

	const HandleFilterReset = () => {

		setFilter({
			category: [],
			minPrice: "",
			maxPrice: "",
			onSale: false,
		});

		setCategoriesMenu((prev) => prev.map((item) => ({ ...item, selected: false })));
		setPage(1);

	};

	const HandleSave = () => {

		setPage(1);

	};

	const HandleSorting = async (params) => {

		setSorting(params);
		setPage(1);
		setIsLoading(true);
		setBrands([]);

	};

	/* START FUNC HANDLE QUICK REVIEW & ADD TO CART */
	const HandleQuickReview = async (params) => {

		setModalQuickReview(true);
		setIsloadingQuickReview(true);
		const resProduct = await Axios(
			`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/api/fds-product/${params}`,
		);
		const resProductData = resProduct?.data;
		if (
			resProductData?.meta?.code === 200
		) {

			setProductQuickReview(resProductData.data.product);
			setIsloadingQuickReview(false);

		}

	};

	const HandleAddCart = (item) => {

		setPopupShow({
			show: false,
			message: "",
			color: "#323942",
			closable: false,
			redirect: false,
		});
		setAddToCartLoading(true);

		const quoteID = Cookies.get("quoteId");
		const authSso = Cookies.get("token");

		if (!authSso && !quoteID) {

			setPopupShow({
				show: true,
				message: "Mohon refresh halaman ini",
				color: "#FF4D4F!important",
				closable: false,
				redirect: true,
			});

		} else {

			createCart({
				data: {
					sku: item.sku,
					qty: "1",
				},
			})
				.then((resp) => {

					if (
						resp?.status >= 200
						&& resp?.status < 300
						&& resp?.data?.data?.item_id
					) {

						if (isProduction) {

							tiktokPixel.track("AddToCart", {
								content_name: resp.data.data.name,
								content_type: "product",
								brand: item.brands.brand_name,
								sku: resp.data.data.sku,
								content_ids: [resp.data.data.item_id],
								value: resp.data.data.price,
								currency: "IDR",
								qty: resp.data.data.qty,
							});

							metaPixel.standardEvent("AddToCart", {
								content_name: resp.data.data.name,
								content_type: "product",
								brand: item.brands.brand_name,
								sku: resp.data.data.sku,
								content_ids: [resp.data.data.item_id],
								value: resp.data.data.price,
								currency: "IDR",
								qty: resp.data.data.qty,
							});

							gtag.event({
								eventName: "add_to_cart",
								parameter: {
									id: resp.data.data.item_id,
									name: resp.data.data.name,
									brand: item.brands.brand_name,
									sku: resp.data.data.sku,
									value: resp.data.data.price,
									currency: "IDR",
									quantity: resp.data.data.qty,
									event_category: "add_to_cart",
									event_label: "add_to_cart",
								},
							});

						}

						dispatch(loadCartBadgeCount());

						return resp;

					}

					if (resp?.data?.meta?.msg === "The requested qty is not available") {

						return setPopupShow({
							show: true,
							message: "Orderan anda melebihi jumlah stock",
							color: "#FF4D4F",
							closable: true,
							redirect: false,
						});

					}
					if (
						!authSso
						&& resp?.data?.meta?.msg === "The consumer isn't authorized to access %resources."
					) {

						return setPopupShow({
							show: true,
							message: "Silahkan anda login terlebih dahulu",
							color: "#FF4D4F",
							closable: true,
							redirect: false,
						});

					}

					throw new Error(resp?.data?.meta?.msg);

				})
				.then(async (resp) => {

					if (resp?.status >= 200
						&& resp?.status < 300
						&& resp?.data?.data?.item_id
					) {

						const productRecommendations = await getProductRecommendations(item.id, dispatch);

						setAddToCartPopupShow({
							show: true,
							addedProduct: {
								...resp.data.data,
								requested_qty: 1,
							},
							productRecommendations: productRecommendations.data.data,
						});

					}

				})
				.catch((err) => {

					// console.log(`Error add cart : ${err}`);
					setPopupShow({
						show: true,
						message: `${err.message}`,
						color: "#FF4D4F !important",
						closable: true,
						redirect: false,
					});

				})
				.finally(() => {

					setAddToCartLoading(false);

				});

		}

	};

	/* END FUNC HANDLE QUICK REVIEW & ADD TO CART */

	const brandDetailName = BrandDetail?.brand_name ?? "";

	return (
		<Layout
			home
			title="Femaledaily"
			typeNavbarSecondary="type-2"
			titleNavbar={brandDetailName}
			ismobile={data.isMobile}
			self={data.getStoreSelf}
			categoryDesktop={data && data.storeCategoryDesktop}
			getQuoteIdErrMessage={data.getQuoteIdErrMessage}
			metaDescription={
				data
				&& (BrandDetail?.Meta?.meta_description
					|| `Jual Produk ${brandDetailName} Asli dan Lengkap di FD Studio by Female Daily.`)
			}
			metaKeywords={data && BrandDetail?.Meta?.meta_keywords}
			metaTitle={
				data
				&& (BrandDetail?.Meta?.meta_title?.split("|")[0]
					|| `Belanja Online ${brandDetailName}`)
			}
		>
			{data.isMobile ? (
				<Mobile
					isLoading={Object.keys(BrandDetail).length > 0 && isLoading}
					data={data && data.storeBrands && BrandDetail}
					slug={data && data.query && BrandDetail.brand_name}
					showFilter={isShowFilter}
					handleShowFilter={(val) => setShowFilter(val)}
					showSorter={isShowSorter}
					handleShowSorter={(val) => setShowSorter(val)}
					filter={filter}
					handleFilter={(type, val, input) => HandleFilter(type, val, input)}
					handleRemove={(type, val) => HandleFilterRemove(type, val)}
					handleSave={HandleSave}
					categories={categoriesMenu}
					sale={sale}
					handleSaleSelected={() => setSale(!sale)}
					sorting={Data.SORT_BY}
					sortingSelected={sorting}
					handleSetSorting={(val) => HandleSorting(val)}
					listProducts={brands}
					loader={loader}
					handleFilterReset={HandleFilterReset}
					totalPage={totalPage}
					page={page}
					handleLoadMore={
						Object.keys(BrandDetail).length > 0
							? (val) => HandleLoadMore(val)
							: () => {}
					}
				/>
			) : (
				<Desktop
					isLoading={Object.keys(BrandDetail).length > 0 && isLoading}
					total={total}
					data={data?.storeBrands && BrandDetail}
					slug={data?.query && BrandDetail?.brand_name}
					listProducts={brands}
					showSorter={isShowSorter}
					handleShowSorter={(val) => setShowSorter(val)}
					sorting={Data.SORT_BY}
					sortingSelected={sorting}
					handleSetSorting={(val) => HandleSorting(val)}
					handleQuickReview={HandleQuickReview}
					HandleAddCart={HandleAddCart}
					filter={filter}
					handleFilter={(type, val, input) => HandleFilter(type, val, input)}
					handleFilterRemove={(type, val) => HandleFilterRemove(type, val)}
					setShowCategoryFilter={(val) => setShowCategoryFilter(val)}
					showCategoryFilter={showCategoryFilter}
					showAllCategories={showAllCategories}
					setShowAllCategories={(val) => setShowAllCategories(val)}
					categoriesMenu={categoriesMenu}
					loader={loader}
					handleFilterReset={HandleFilterReset}
					totalPage={totalPage}
					page={page}
					handleLoadMore={
						Object.keys(BrandDetail).length > 0
							? (val) => HandleLoadMore(val)
							: () => {}
					}
				/>
			)}

			{addToCartLoading && (
				<>
					<div className="fdn-loader">
						<Loader />
					</div>
					<style>
						{`
								.fdn-loader {
									position:absolute;
								}
							`}
					</style>
				</>
			)}
			<Popup
				isMobile={data.isMobile}
				color={popupShow?.color}
				show={popupShow?.show}
				onHide={() => {

					setPopupShow(false);

					if (popupShow?.redirect) {

						window.location.href = `${process.env.NEXT_PUBLIC_SSO_DOMAIN}/my/account`;

					}

				}}
				closable={popupShow?.closable}
				text={popupShow?.message}
				withOk={false}
			/>
			<ModalQuickReview
				show={isModalQuickReview}
				onClick={() => setModalQuickReview(false)}
				closable
			>
				<ChildDetailQuickReview
					data={productQuickReview}
					isLoading={isLoadingQuickReview}
					closeModal={() => setModalQuickReview(false)}
					setPopupShow={(e) => setPopupShow(e)}
					setAddToCartLoading={(e) => setAddToCartLoading(e)}
					setAddToCartPopupShow={(e) => setAddToCartPopupShow(e)}
				/>
			</ModalQuickReview>

			<Drawer
				isMobile={false}
				contentBackground="#FFF"
				title="Added to Cart!"
				headerIconSrc="https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/fdn-studio-new/static/added-to-cart.png"
				onHide={() => setAddToCartPopupShow((prev) => ({
					show: false,
					addedProduct: prev.addedProduct,
					productRecommendations: prev.productRecommendations,
				}))}
				type="with-overlay"
				show={addToCartPopupShow?.show}
			>
				<AddToCartPopup
					isMobile={false}
					addedProduct={addToCartPopupShow?.addedProduct}
					productRecommendations={addToCartPopupShow?.productRecommendations}
				/>
			</Drawer>

		</Layout>
	);

};

export const getServerSideProps = wrapper.getServerSideProps(
	async ({
		store, req, res: resServer, query,
	}) => {

		let userAgent;
		let authorization = null;
		let usrname = null;

		let sorting = null;
		let selectedCategory = [];
		let listCategory = [];

		if (req) {

			// if you are on the server and you get a "req" property from your context
			userAgent = req.headers["user-agent"]; // get the user-agent from the headers

		} else {

			// if you are on the client you can access the navigator from the window object
			userAgent = navigator.userAgent;

		}

		const isMobile = Boolean(
			userAgent.match(
				/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i,
			),
		);

		const isServer = !!req;

		const Cookie = new ServerCookies(req, resServer);

		if (req.headers.cookie) {

			authorization = Cookie.get("token");
			usrname = Cookie.get("usrname");

		}

		await store.dispatch(
			loadSelf({
				payload: {
					api_env: process.env.NEXT_PUBLIC_NODE_ENV,
					env: Env.HEADERS,
					usrname,
					Authorization: authorization,
					is_server: isServer,
				},
			}),
		);

		await store.dispatch(
			loadBrands({
				payload: {
					slug: query?.slug,
				},
			}),
		);

		await store.dispatch(
			loadCategoryDesktop({
				payload: {
					is_server: isServer,
				},
			}),
		);

		store.dispatch(END);
		await store.sagaTask.toPromise();

		const categoryNavigationDesktop = [];
		const brands = {
			id: 200,
			name: "Brands",
			slug: "brands",
			items: [],
		};
		const extractCatBySlug = {};
		const extractCatById = {};

		const getStoreSelf =			store.getState().storeSelf
			&& typeof store.getState().storeSelf.data !== "undefined"
			? store.getState().storeSelf
			: null;

		const getStoreBrand =	store.getState().storeBrands.data
			&& typeof store.getState().storeBrands.data.data !== "undefined"
			? store.getState().storeBrands.data
			: null;

		const getStoreCategoryDesktop =			store.getState().storeCategoryDesktop.data
			&& typeof store.getState().storeCategoryDesktop.data.data
				!== "undefined"
			? store.getState().storeCategoryDesktop.data
			: null;

		getStoreCategoryDesktop?.data
			&& getStoreCategoryDesktop.data[0]
			&& getStoreCategoryDesktop.data[0].children_data
				?.filter((val) => val.include_in_menu === "1")
				.map((item) => {

					categoryNavigationDesktop.push({
						id: item.entity_id,
						name: item.category_name,
						slug: item.category_path,
						items:
							item.children_data.length > 0
								? item.children_data.map((child) => ({
									id: child.entity_id,
									name: child.category_name,
									slug: child.category_path,
									items:
											child.children_data.length > 0
												? child.children_data.map(
													(childs) => ({
														id: childs.entity_id,
														name: childs.category_name,
														slug: childs.category_path,
														items:
																childs
																	.children_data
																	.length > 0
																	? childs.children_data.map(
																		(
																			lastChilds,
																		) => ({
																			id: lastChilds.entity_id,
																			name: lastChilds.category_name,
																			slug: lastChilds.category_path,
																		}),
																	  )
																	: [],
													}),
												  )
												: [],
								  }))
								: [],
					});

				});
		categoryNavigationDesktop.splice(1, 0, brands);

		if (query?.sort) {

			sorting = query.sort;

		}

		if (query?.category) {

			if (query.category.indexOf(",") > -1) {

				selectedCategory = query.category.split(",");

			} else {

				selectedCategory = [query.category];

			}

		}

		listCategory = categoryNavigationDesktop[0].items.map((cat) => {

			const catItems = cat?.items;

			if (catItems) {

				catItems.map((child) => {

					extractCatBySlug[String(cat.slug.split("/")[2])] = child.id;
					extractCatById[child.id] = String(child.slug.split("/")[2]);

					if (selectedCategory.includes(String(child.slug.split("/")[2]))) {

						return { ...child, slug: String(child.slug.split("/")[2]), selected: true };

					}

				});

			}
			if (selectedCategory.includes(String(cat.slug.split("/")[1]))) {

				return { ...cat, slug: String(cat.slug.split("/")[1]), selected: true };

			}

			return { ...cat, slug: String(cat.slug.split("/")[1]), selected: false };

		});

		return {
			props: {
				query,
				sorting,
				selectedCategory,
				listCategory,
				isMobile,
				getStoreSelf,
				storeBrands: getStoreBrand || null,
				storeCategoryDesktop: categoryNavigationDesktop || null,
				extractCatBySlug,
				extractCatById,
				getQuoteIdErrMessage: null,
			}, // will be passed to the page component as props
		};

	},
);

export default Slug;
